<template>
  <div class="comment_patting">
    <!-- 视频轮播 -->
    <swiper
      :options="swiperOption"
      class="swiper-wrap"
      id="swiper-wrap"
      v-if="swiperData.length != 0"
    >
      <swiper-slide v-for="(item, index) in swiperData" :key="index">
        <div class="video-box">
          <!-- 播放按钮 -->
          <div class="video_paly_btn" ref="videoBtn"></div>
          <!--右边操作栏-->
          <div class="option-fr">
            <a class="option-head">
              <img :src="item.user ? item.user.image : ''" />
              <i @click="toggleBox" class="po_x"></i>
            </a>
            <a class="icon-option zan-option" @click="toggleBox(0)">
              <i></i>
              <p>{{ item.like }}</p>
            </a>
            <a class="icon-option comment-option" @click="toggleBox(0)">
              <i></i>
              <p>{{ item.comment }}</p>
            </a>
            <a class="icon-option share-option" @click="toggleBox(1)">
              <i></i>
            </a>
            <a class="icon-option production-option" @click="toggleBox(0)">
              <i></i>
            </a>
          </div>
          <video-player
            class="video-player vjs-custom-skin"
            ref="videoPlayer"
            :playsinline="true"
            :options="playerOptions"
          >
            <!-- <source src="https://www.runoob.com/try/demo_source/movie.mp4" type='video/mp4' /> -->
          </video-player>
          <div class="video-infor">
            <div class="clear Label-list">
              <div @click="jumpTopic(item.tag.id)">
                <i></i><span>{{ item.tag ? item.tag.title : "" }}</span>
              </div>
            </div>
            <div>
              <a class="video-name">@{{ item.author }}</a>
              <div class="video-flex">
                <p class="video-p">{{ item.content }}</p>
                <a
                  @click="toggleBox"
                  class="icon-option bottom-option"
                  style="margin-left: 34px"
                  ><i class="po"></i
                ></a>
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <!--评论弹层-->
    <div class="swiper-comment flex-comment" v-show="isPl">
      <div class="swiper-commentPo">
        <div class="swiper-title">
          123条评论<i class="swiper-close fr" @click="toggleBox(0)"></i>
        </div>
        <ul class="swiper-ul">
          <li class="clear">
            <a class="swiper-ul-head fl">
              <img :src="test" class="display-a" />
            </a>
            <div class="swiper-ov">
              <div class="clear">
                <a class="fl swiper-bt">东莞阳光台</a>
                <div class="swiper-zan fr"><i></i>234</div>
              </div>
              <a class="swiper-comTit"
                >高端个大气上档次，低调奢华有内涵，不错，我很喜欢</a
              >
              <div class="comTit-hf">
                <span>胖胖小浣熊：</span>哇，我也很喜欢！支持东莞
              </div>
              <div class="Shell-review clear">
                <span class="fl">1小时前</span>
                <a class="fr">举报</a>
              </div>
            </div>
          </li>
          <li class="clear">
            <a class="swiper-ul-head fl">
              <img :src="test" class="display-a" />
            </a>
            <div class="swiper-ov">
              <div class="clear">
                <a class="fl swiper-bt">东莞阳光台</a>
                <div class="swiper-zan fr"><i></i>234</div>
              </div>
              <a class="swiper-comTit"
                >高端个大气上档次，低调奢华有内涵，不错，我很喜欢</a
              >
              <div class="Shell-review clear">
                <span class="fl">1小时前</span>
                <span class="fr">举报</span>
              </div>
            </div>
          </li>
          <li class="clear">
            <a class="swiper-ul-head fl">
              <img :src="test" class="display-a" />
            </a>
            <div class="swiper-ov">
              <div class="clear">
                <a class="fl swiper-bt">东莞阳光台</a>
                <div class="swiper-zan fr"><i></i>234</div>
              </div>
              <a class="swiper-comTit"
                >高端个大气上档次，低调奢华有内涵，不错，我很喜欢</a
              >
              <div class="comTit-hf">
                <span>胖胖小浣熊：</span>哇，我也很喜欢！支持东莞
              </div>
              <div class="Shell-review clear">
                <span class="fl">1小时前</span>
                <span class="fr">举报</span>
              </div>
            </div>
          </li>
        </ul>
        <div class="Write-comments">
          <input type="text" placeholder="写评论，我光荣！" />
        </div>
      </div>
    </div>

    <!--分享弹层-->
    <div class="swiper-comment share-tc" v-show="isShare">
      <div class="swiper-commentShare">
        <div style="padding: 0 16px">
          <ul class="clear share-flex">
            <li>
              <a>
                <i class="Moments-i"></i>
                <p>朋友圈</p>
              </a>
            </li>
            <li>
              <a>
                <i class="WeChat-i"></i>
                <p>微信好友</p>
              </a>
            </li>
            <li>
              <a>
                <i class="Webo-i"></i>
                <p>新浪微博</p>
              </a>
            </li>
            <li>
              <a>
                <i class="qq-i"></i>
                <p>QQ</p>
              </a>
            </li>
            <li>
              <a>
                <i class="qqz-i"></i>
                <p>Qzone</p>
              </a>
            </li>
          </ul>
          <ul class="clear share-flex mr-two">
            <li>
              <a>
                <i class="production-i"></i>
                <p>合拍</p>
              </a>
            </li>
            <li>
              <a>
                <i class="download-i"></i>
                <p>下载</p>
              </a>
            </li>
            <li>
              <a>
                <i class="Collection-i"></i>
                <p>收藏</p>
              </a>
            </li>
            <li>
              <a>
                <i class="Report-i"></i>
                <p>举报</p>
              </a>
            </li>
            <li>
              <a>
                <i class="ReplicationLink-i"></i>
                <p>复制链接</p>
              </a>
            </li>
          </ul>
        </div>
        <div class="cancel-share" @click="toggleBox(1)">取消</div>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import { getPattingComment } from "@/request/api";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import Contents from "@/request/base.default.js";
import { navigate, checkWx } from "@/pages/index/custom";

export default {
  components: {
    videoPlayer,
    swiper,
    swiperSlide,
  },
  data() {
    let that = this;
    return {
      test: require("../Information/images/img3.png"),
      // 评论弹层
      isPl: false,
      // 分享弹窗
      isShare: false,
      // 轮播数据
      swiperData: [],
      // 视频配置
      playerOptions: {
        // playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
        autoplay: false, //如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: true, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        // aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [],
        poster: "", //你的封面地址
        width: document.documentElement.clientHeight, //视频播放器显示的宽度
        height: document.documentElement.clientWidth, //视频播放器显示的高度
        notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: false,
      },
      // 视频封面
      v_poster: [],
      // 轮播配置
      swiperOption: {
        //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
        notNextTick: true,
        initialSlide: 0,
        //循环
        loop: false,
        mousewheel: false,
        //自动播放
        autoplay: false,
        //滑动速度
        speed: 300,
        //滑动方向
        direction: "vertical",
        //小手掌抓取滑动
        grabCursor: false,
        on: {
          //滑动之后回调函数
          slideChangeTransitionEnd: function (aa) {
            let index = this.realIndex;
            that.$refs.videoPlayer[index].player.on("play", function () {
              that.$refs.videoBtn[index].style.display = "none";
            });
            that.$refs.videoPlayer[index].player.on("ended", function () {
              that.$refs.videoBtn[index].style.display = "block";
            });
            if (index > 0) {
              that.$refs.videoPlayer[index - 1].player.pause();
            }
            if (index < that.$refs.videoPlayer.length - 1) {
              that.$refs.videoPlayer[index + 1].player.pause();
            }
            if (index == that.swiperData.length - 1) {
              that.initVideoList(
                that.swiperData[index].id,
                that.$refs.videoPlayer[index]
              );
            } else {
              that.$refs.videoPlayer[index].player.play();
            }
          },
          reachEnd: function () {
            // that.initVideoList(that.swiperData[this.realIndex].id, true);
          },
          click: function () {
            var elem = that.$refs.videoPlayer[this.realIndex].player;
            var elemBtn = that.$refs.videoBtn[this.realIndex];
            if (elem.paused()) {
              elem.play();
              elemBtn.style.display = "none";
            } else {
              elem.pause();
              elemBtn.style.display = "block";
            }
          },
        },
      },
    };
  },
  methods: {
    toggleBox(index) {
      if (checkWx()) {
        navigate("", Contents.downURL + "?mini=1");
      } else {
        navigate("", Contents.downURL);
      }
      // if(index === 0) {
      //     this.isPl = !this.isPl;
      // } else if(index === 1) {
      //     this.isShare = !this.isShare;
      // }
    },
    jumpTopic(id) {
      navigate({ path: "/patTopDetails", query: { id: id } });
    },
    // 获取频道/栏目
    initVideoList(id = null, resetImg = false) {
      getPattingComment({
        id: id ? id : 0,
      })
        .then((res) => {
          let { data, error_code } = res;
          if (error_code === 0) {
            var index = this.swiperData.length;
            for (const item of data) {
              if (!item.adv_data) {
                this.swiperData.push(item);
                this.v_poster.push(item.cover);
              }
            }
            if (resetImg && index > 0) {
              var videos = this.$refs.videoPlayer;
              setTimeout(() => {
                this.swiperData.forEach((item, i) => {
                  videos[i].player.poster(this.v_poster[i]);
                });
                resetImg.player.play();
              }, 500);
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {
    player() {
      return this.$refs.videoPlayer.player;
    },
  },
  updated() {
    let videoList = this.$refs.videoPlayer;
    let that = this;
    videoList.forEach((item, index) => {
      item.player.src([
        {
          src: that.swiperData[index].video,
        },
      ]);
    });
  },
  mounted() {
    this.$nextTick(() => {
      this._timer = setInterval(() => {
        var videos = this.$refs.videoPlayer;
        if (videos) {
          videos.forEach((item, index) => {
            item.player.poster(this.v_poster[index]);
          });
          var playBtn = this.$refs.videoBtn[0];
          clearInterval(this._timer);
          videos[0].player.play();
          videos[0].player.on("play", function () {
            playBtn.style.display = "none";
          });
          videos[0].player.on("ended", function () {
            playBtn.style.display = "block";
          });
        }
      }, 500);
    });
  },
  beforeCreate: function () {
    document.getElementsByTagName("html")[0].style.height = "100%";
    document.getElementsByTagName("body")[0].style.height = "100%";
  },
  destroyed() {
    clearInterval(this._timer);
  },
  created() {
    this.initVideoList();
  },
};
</script>

<style lang="less">
.comment_patting {
  width: 100%;
  height: 100%;
  background-color: #000;
  .c_videoBox,
  .video-player {
    width: 100%;
    height: 100%;
  }
  .swiper-wrap {
    width: 100%;
    height: 100%;
  }
  .video_paly_btn {
    position: absolute;
    width: 40px;
    height: 52px;
    top: 50%;
    left: 50%;
    margin-left: -20px;
    margin-top: -26px;
    background: url(../../../../assets/img/icon_video_play.png) no-repeat center
      center;
    background-size: 100% 100%;
    z-index: 1111;
    display: block;
  }
}
</style>
